// extracted by mini-css-extract-plugin
export default {"divider":"Entry_divider__dqYiv","orText":"Entry_orText__4X+KW"};